<div>
  <div data-testid="notification-controls" class="notification-controls">
    <dx-check-box [value]="selectAllChecked()" [text]="selectAllChecked() ? 'Deselect All' : 'Select All'"
      (click)="onSelectAllChange()" />
    <div class="notification-controls-inner">
      <dx-text-box name="search" class="search-box" placeholder="Search" [showClearButton]="true"
        valueChangeEvent="input" [value]="searchTerm()" (onValueChanged)="onSearchTermChange($event)">
        <dxi-text-box-button name="clear" />
      </dx-text-box>
      <dx-button stylingMode="outlined" [text]="'Mark ' + selectedItems().length + ' as Read'"
        type="danger" [width]="150" [disabled]="!hasSelectedItems()" (click)="markAsRead(selectedItems())" />
    </div>
  </div>
  <div data-testid="notifications-container" class="notifications-container">
    @for(notification of notifications(); track notification.id) {
    <div class="notification-card">
      <div class="notification-check-box">
        <dx-check-box [value]="isItemSelected(notification.id)"
          (onValueChanged)="onItemSelectionChange(notification.id, $event)">
        </dx-check-box>
      </div>
      <div class="notiication-content">
        <div class="notification-header">
          <div class="notification-title">{{ notification.title }} - {{ notification.taskName }}</div>
        </div>

        <div class="notification-meta">
          <div class="notification-task" *ngIf="notification.taskName">
            <strong>Time:</strong> {{ notification.updatedTimestamp | date:'short' }}
          </div>
          <div class="notification-sender">
            <strong>From:</strong> {{ notification.sender }}
          </div>
        </div>

        <div class="notification-body">
          {{ notification.body }}
        </div>
      </div>
      <div class="notification-actions">
        <dx-button stylingMode="contained" text="Mark as Read" type="danger" [width]="150"
          (click)="markAsRead([notification.id])" />
        <dx-button stylingMode="contained" text="View Task" type="normal" [width]="150"
          (click)="openLink(notification.taskId)" />
      </div>
    </div>
    } @empty {
    @if(!isLoading() && !initialising() ) {
    <div class="no-notifications">
      No Notifications Found
    </div>
    }
    }
  </div>
  @if(totalNotifications() > 0) {
  <div data-testid="notification-pagination" class="notification-pagination">
    <dx-pagination [showInfo]="true" [showNavigationButtons]="true" [itemCount]="totalNotifications()"
      [pageIndex]="pageIndex()" [allowedPageSizes]="pageSizeOptions" [pageSize]="pageSize()"
      (pageSizeChange)="onPageSizeChange($event)" (pageIndexChange)="onPageIndexChange($event)" />
  </div>
  }
</div>


<dx-load-panel data-testid="notification-load-panel" container=".notifications-container"
  [position]="{ of: '.notifications-container' }" [visible]="isLoading() || isUpdating()" [showPane]="true" width="100"
  height="100" />